import { render, staticRenderFns } from "./DojoTest.vue?vue&type=template&id=7c2b2d43&"
import script from "./DojoTest.vue?vue&type=script&lang=js&"
export * from "./DojoTest.vue?vue&type=script&lang=js&"
import style0 from "./DojoTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports